/*
  英语
*/
export default {
  commodity: {
    Components: {
      Select: {
        SearchFor: 'Search for'
      },
      Search: {
        UploadAPicture: 'upload a picture'
      },
      Sale: {
        AutumnWinter: 'Autumn-Winter',
        SpringSummer: 'Spring-Summer',
        FourSeasons: 'Four Seasons',
        Festival: 'Festival'
      },
      ReturnRefund: {
        Tips1: 'To create a great trading environment and improve the services of KakaClo, KakaClo hereby issue the general policy to return and refund behavior. This Policy applies to all users on KakaClo.',
        Accept: 'Accept',
        Tips2: 'KakaClo reserves the right to update the rules when necessary, and the updated version will be published on KakaClo with immediate effect. If you refuse to accept the policy, you are deemed to have waived the use of the services provided by KakaClo immediately. All buyers or suppliers are deemed to accept the rules if they are using the services provided by KakaClo.',
        Tips3: 'For after-sales issues, buyers should file a return & refund application within 30 days from the delivery day.',
        Tips4: 'Once the buyer submits the after-sales application, he/she needs to provide evidence (as the clause said below) to the KakaClo. If the buyer cannot provide compelling evidence in time, the KakaClo have the right to reject the refund or return the application.',
        Tips5: 'All items must be returned in good condition with original box/packaging, including manufacturer tags, parts, and accessories.',
        Tips6: 'Whether the evidence is compelling or not will ultimately be determined by KakaClo.',
        Tips7: 'Under Various Circumstances:',
        Tips8: '1. Not shipped after processing time',
        Tips9: 'The buyer has the right to apply for a full refund for the order that was not shipped out beyond the processing time (subject to the estimated processing time displayed on the order page).',
        Tips10: '2. Wrong receipt information',
        Tips11: 'If the buyer fills in the receiving information incorrectly, please contact the customer service or docking personnel in time to confirm whether the goods have been shipped.',
        Tips12: 'If there is no delivery, the buyer can update the delivery address with the correct information.',
        Tips13: 'If the goods have been shipped, the buyer needs to contact the logistics company to redeliver.',
        Tips14: 'If the refund application is approved, the buyer must return the product at his own expense and upload the return tracking information in a timely manner. After KakaClo receives the returned goods without any damage, part of the order amount will be deducted as the cost of repackaging and restocking.',
        Tips15: 'If the goods cannot be redistributed or returned, the buyer shall bear the corresponding losses.',
        Tips16: 'Note: In this case, KakaClo has the right to refuse the refund application.',
        Tips17: '3. Non-Defective Products',
        Tips18: 'If the buyer applies for a return and refund for non-defective products the buyer must send back the product at his/her own expense and upload the return tracking info in time. After the KakaClo receives the returned items without any damage, a portion of the order amount will be deducted as the repacking & restocking fee. Note: the KakaClo has the right to reject the refund application under this circumstance.',
        Tips19: '4. Defective Products (package breakage/significantly not as described/missing or wrong goods/quality problems)',
        Tips20: 'If the buyer detects any problem upon receipt (damaged package/significantly not as described/missing or wrong goods or other quality problems),He / she shall contact KakaClo customer service or handle the receiver within 5 working days from the date of delivery.and provide evidence to prove the problem (pictures of broken products and package outer box with a shipping label on it). The KakaClo may refuse the refund application if the buyer fails to provide compelling evidence in time.',
        Tips21: 'For any problem raised in the process of using the product, Buyers should contact KakaClo for communication within 30 days from the date of shipment,and provide relevant pictures or videos as evidence. If the feedback time is more than 30 days from the delivered time, or the buyer provides insufficient evidence, the KakaClo may refuse the refund application if the buyer fails to provide compelling evidence in time.',
        Tips22: 'If the KakaClo agrees to refund, the buyer shall return the goods in time and upload the tracking number. The KakaClo will refund in full upon receipt.',
        Tips23: 'If the buyer agrees to resend, the buyer shall return and upload the tracking number in time. The KakaClo will reship the product upon receipt. If both parties failed to reach an agreement, the buyer shall contact KakaClo and provide relevant evidence (picture or video of the problem goods). Once the evidence is verified, KakaClo will proactively assist the buyer to get a corresponding refund.',
        Tips24: '5. Logistics issues',
        Tips25: '5.1 Invalid tracking information',
        Tips26: 'If KakaClo verifies that the tracking number is incorrect, the buyer should contact us in time. Check and re-give an accurate tracking number',
        Tips27: '5.2 Untimely tracking info updates',
        Tips28: 'If there is no update of the tracking info for more than 10 business days (from the time in the logistics website tracking info),buyers should contact KakaClo customer service or docking person in time to negotiate a solution.Note: this clause is not applicable for special time/periods such as holidays, covid-19, abnormal weather, or other abnormal situations.',
        Tips29: '5.3 Package not received',
        Tips30: 'If the transit time exceeds the estimated delivery time by 10 days or more and the supplier fails to provide proof of delivery, Buyers should contact KakaClo customer service or docking staff in time',
        Tips31: '6. Others',
        Tips32: 'When encounter holidays, covid-19, abnormal weather, or other abnormal situations, Buyers should contact KakaClo customer service or docking staff in timeto solve the goods or logistic issues.',
        Tips33: 'For any issue received, KakaClo will make a judgment based on the facts. The maximum judging time is two weeks after KakaClo intervened.',
        Tips34: 'For return issues, please contact the corresponding customer service first to match the nearest warehouse.',
        Tips35: '7. Contact Us'
      },
      NewTime: {
        NewIn: 'New In'
      },
      CustomerReviews: {
        NoReviewsYet: 'No reviews yet.',
        Tips1: 'Be the first to write a review.',
        Color: 'Color',
        Size: 'Size',
        ViewMore: 'view More',
        Tips2: "Women's halter ruffle open back print dress",
        SubmitReview: 'Submit review',
        WriteAReview: 'Write a Review',
        Select: 'select',
        Tips3: 'Write a short review',
        YourName: 'Your name',
        YourEmailAddress: 'Your email address',
        Review: 'Review',
        Name: 'Name',
        Email: 'Email'
      },
      AddingToBag: {
        AddingToBagSucceed: 'Adding to bag succeed',
        Item: 'Item',
        Subtotal: 'Subtotal',
        ViewMyBag: 'View My bag',
        ContinueShopping: 'Continue Shopping'
      }
    },
    ProductDetail: {
      ShipFrom: 'Ship From',
      ShopSimilar: 'Shop Similar',
      EndIn: 'End in',
      Over: 'over',
      Sales: 'Sales',
      Shipping: 'Shipping',
      NoLogisticsChannel: 'No logistics channel',
      ShipTo: 'Ship To',
      Cost: 'Cost',
      Color: 'Color',
      PACK: 'PACK',
      QTY: 'QTY',
      AMT: 'AMT',
      ResetQty: 'Reset Qty',
      SoldOut: 'Out of Stock',
      Sizing: 'Sizing',
      TrueToSize: 'True to size',
      MaterialComposition: 'Material composition',
      SizeChart: 'Size Chart',
      TableData: 'tableData',
      InchData: 'inchData',
      WeThinkYoullLoveThese: 'We think you’ll love these',
      China: 'China',
      CanSupportMostCountryConfigurations: 'Can support most country configurations',
      Germany: 'Germany',
      OnlyLocalCountryConfigurationsAreSupported: 'Only local country configurations are supported.',
      ForExample: 'For example',
      USProductsAreOnlySupportedForShippingToTheUS: 'US products are only supported for shipping to the US.',
      DeliveryTime: 'Delivery time',
      AllVariants: 'All Variants',
      SelectAll: 'Select All',
      Inventory: 'Inventory',
      AddToBag: 'Add to Bag',
      Total: 'Total',
      Pieces: 'pieces',
      tableData: 'tableData',
      inchData: 'inchData',
      SignIn: 'Sign in to unlock full content',
      SignInSignUp: 'Sign In / Sign Up'
    },
    PaymentStatus: {
      Payment: 'Payment',
      PaymentSuccessful: 'Payment Successful',
      CheckOrder: 'Check Order',
      BackToShoppingBag: 'Back to Shopping Bag',
      Order: 'Order',
      StoreOrderID: 'Store Order ID',
      OrderID: 'Order ID',
      Source: 'Source',
      ShopifyRtoiweuuyir: 'shopify rtoiweuuyir',
      PaymentTime: 'Payment Time',
      PaymentAmount: 'Payment Amount',
      PaymentMethod: 'Payment Method',
      Balance: 'Balance',
      CreditCard: 'CreditCard',
      Paypal: 'Paypal',
      Others: 'Others',
      EverySingleProductGoesThroughOurRigorousQualityInspectionBeforeWeSendItToYourCustomers: 'Every single product goes through our rigorous quality inspection before we send it to your customers.',
      OrderCreation: 'Order Creation',
      Shipped: 'Shipped',
      Complete: 'Complete',
      PaymentFail: 'Payment Fail',
      Home: 'Home',
      ViewOrder: 'View order',
      Back: 'back'
    },
    InStock: {
      SeachFor: 'Seach For'
    },
    ConfirmOrder: {
      ContactInformation: 'Contact Information',
      AlreadyHaveAnAccount: 'Already have an account?',
      LogIn: 'Log in',
      LoginSuccessful: 'Login Successful',
      Shipping: 'Shipping',
      PromotionalCodes: 'Promotional Codes',
      Apply: 'Apply',
      DeductionForHighestProductPrice: 'Deduction for highest product price.',
      Creditcard: 'Creditcard',
      Paypal: 'Paypal',
      Others: 'Others',
      TipsOne: 'We accept return of products. Customers have the right to apply for a return within 14 days after the receipt of the product.To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging. To complete your return, we require a receipt or proof of purchase. Please do not send your purchase back to the manufacturer.',
      TipsTwo: 'For after-sales issues, buyers should file a return & refund application within 30 days from the delivery day. Once the buyer submits the after-sales application, he/she needs to provide evidence (as the clause said below) to the kakaclo. If the buyer cannot provide compelling evidence in time, the kakaclo have the right to reject the refund or return the application.',
      TipsThree: 'If the buyer fills in the receiving information incorrectly, please contact the customer service or docking personnel in time to confirm whether the goods have been shipped. If there is no delivery, the buyer can update the delivery address with the correct information. If the goods have been shipped, the buyer needs to contact the logistics company to redeliver. If the refund application is approved, the buyer must return the product at his own expense and upload the return tracking information in a timely manner. After kakaclo receives the returned goods without any damage, part of the order amount will be deducted as the cost of repackaging and restocking. If the goods cannot be redistributed or returned, the buyer shall bear the corresponding losses.',
      AddANewAddress: 'Add A New Address',
      ShipMethod: 'Ship Method',
      AnotherMethod: 'Another method',
      DeliveryTime: 'Delivery Time',
      Cost: 'Cost',
      ShippingCost: 'Shipping Cost',
      CustomizedService: 'Customized Service',
      PaymentMethod: 'Payment Method',
      OrderAmount: 'Order Amount',
      Email: 'Email',
      RegisterAsANewAccount: 'Register as a new account',
      // LeaveUsYourRequirement: 'Leave us your requirement',
      LeaveUsYourRequirement: 'Add A Note to KakaClo',
      Package: 'Package',
      Bags: 'Bags',
      Cards: 'Cards',
      CouponCode: 'Coupon Code',
      Get: 'Get',
      Tips1: 'Please enter your vaild email',
      Tips2: 'Please enter the password',
      Tips3: 'Please enter a password of 6 to 20 characters',
      InputContent: 'input content',
      Tips4: 'How to return',
      Tips5: 'Return and return issues',
      Tips6: 'Wrong receipt information'
    },
    CategoryDetail: {
      InStock: 'In-stock',
      Search: 'Search',
      ResultsFound: 'results found',
      Fabric: 'Fabric',
      Price: 'Price',
      Products: 'Products',
      ClearAll: 'Clear All',
      Submit: 'submit',
      ShipFrom: 'Ship From'
    },
    pcDetail: {
      ShopSimilar: 'Shop Similar',
      Sales: 'Sales',
      EndIn: 'End in',
      Over: 'over',
      ShipTo: 'Ship To',
      ShipFrom: 'Ship From',
      China: 'China',
      ShipToMoreThan200CountriesAcrossTheGlobe: 'Ship to more than 200 countries across the globe.',
      Germany: 'Germany',
      ShipItemsOnlyWithinTheCountry: 'Ship items only within the country.',
      TipsOne: 'For example:US products are only supported for shipping to the US.',
      DeliveryTime: 'Delivery time',
      NoLogisticsChannel: 'No logistics channel',
      SoldOut: 'Out of Stock',
      Total: 'Total',
      Pieces: 'pieces',
      ResetQty: 'Reset Qty',
      See20SimilarStyles: 'See 20+ Similar Styles',
      WeThinkYouLlLoveThese: 'We think you’ll love these',
      Sizing: 'Sizing',
      TrueToSize: 'True to size',
      MaterialComposition: 'Material composition',
      TableData: 'tableData',
      InchData: 'inchData',
      Cost: 'Cost',
      PleaseSelect: 'Please Select',
      AllVariants: 'All Variants'
    }
  }
}
